const SM = 480;
const MD = 768;

export default {
    namespaced: true,
    state: {
        width: window.innerWidth,
        height: window.innerHeight,
        ctrlKey: false,
        shiftKey: false,
        spaceKey: false,
        isDragging: false,
        isSelecting: false,
        dialogOpen: false,
        dropdownOpen: false,
    },
    getters: {
        height(state) {
            return state.height;
        },
        mainHeight(state, getters, rootState, rootGetters) {
            let height = getters.height;
            if (rootGetters['layout/showNav']) {
                height -= rootGetters['layout/dimensions'].heightNavBar;
            }
            return height;
        },
        width(state) {
            return state.width;
        },
        smWidth(state) {
            return state.width <= SM;
        },
        mdWidth(state) {
            return state.width > SM && state.width <= MD;
        },
        lgWidth(state) {
            return state.width > MD;
        },
        ctrlKey(state) {
            return state.ctrlKey;
        },
        shiftKey(state) {
            return state.shiftKey;
        },
        spaceKey(state) {
            return state.spaceKey;
        },
        isDragging(state) {
            return state.isDragging;
        },
        isSelecting(state) {
            return state.isSelecting;
        },
        dialogOpen(state) {
            return state.dialogOpen;
        },
        dropdownOpen(state) {
            return state.dropdownOpen;
        }
    },
    mutations: {
        size(state, { width, height }) {
            state.width = width;
            state.height = height;
        },
        ctrlKey(state, pressed) {
            state.ctrlKey = pressed;
        },
        shiftKey(state, pressed) {
            state.shiftKey = pressed;
        },
        spaceKey(state, pressed) {
            state.spaceKey = pressed;
        },
        isDragging(state, isDragging) {
            state.isDragging = isDragging;
        },
        isSelecting(state, isSelecting) {
            state.isSelecting = isSelecting;
        },
        dialogOpen(state, dialogOpen) {
            state.dialogOpen = dialogOpen;
        },
        dropdownOpen(state, dropdownOpen) {
            state.dropdownOpen = dropdownOpen;
        }
    },
    actions: {
    }
}